import { connect } from 'react-redux'
import { getSelectedFlightGroupFirstFlightDate, getSelectedFlightGroupSource, getSelectedFlightGroupDeliverablesVisible } from '../selectors/flightGroups'
import { getAllSelectedFieldTabs } from '../selectors/selectedFieldTabs'
import { setSelectedFieldTab } from '../actions/selectedFieldTabs'
import { expandSelectedFieldsAside, toggleExpandSelectedFieldAside } from '../actions/ui'
import { getSelectedFieldAsideExpanded, getUISeasonLayers, getSeasonLayersBaseZIndex, getGroupDeliverablesBaseZIndex } from '../selectors/ui'
import TabsHeader from '../components/FieldsComponents/TabsHeader'

const mapStateToProps = state => {
  return {
    selectedDate: getSelectedFlightGroupFirstFlightDate(state),
    selectedSource: getSelectedFlightGroupSource(state),
    activeLayers: getSelectedFlightGroupDeliverablesVisible(state),
    allTabs: getAllSelectedFieldTabs(state),
    asideExpanded: getSelectedFieldAsideExpanded(state),
    seasonLayers: getUISeasonLayers(state),
    seasonLayersBaseZIndex: getSeasonLayersBaseZIndex(state),
    groupDeliverablesBaseZIndex: getGroupDeliverablesBaseZIndex(state)
  }
}

const mapDispatchToProps = {
  setSelectedFieldTab,
  expandSelectedFieldsAside,
  toggleExpandSelectedFieldAside
}

export default connect(mapStateToProps, mapDispatchToProps)(TabsHeader)
